import { render, staticRenderFns } from "./event_bookings_list.vue?vue&type=template&id=f9c1e446&"
import script from "./event_bookings_list.vue?vue&type=script&lang=js&"
export * from "./event_bookings_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports